import { Button, TableColumnType } from 'antd'
import moment from 'moment'
import React from 'react'
import { PrintOutlined } from '../../../../compnents/icons/Icons'
import { DateTimeFormatSimple } from '../../../../models/datetime'
import { Dimen } from '../../../../models/dimen'
import { getRegistrationStateName } from '../../../../models/registration'
import { getGenderName } from '../../../../models/user'
import { getAge } from '../../../../utils/StringUtils'

export const doctorcolumn = (
  onclick: (name: any, value?: any) => void,
  startIndex: number
): TableColumnType<any>[] => {
  return [
    {
      title: '序号',
      key: 'no',
      align: 'center',
      width: Dimen.Num,
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    // {
    //   title: "结算险种",
    //   dataIndex: "registrationCategory",
    //   align: "center",
    //   render: function registrationCategory(registrationCategory: number) {
    //     return registrationCategory === 0 ? "自费" : "医保";
    //   },
    // },

    {
      title: '门诊号',
      dataIndex: 'outpatientNo',
      width: '6rem',
      align: 'center',
      ellipsis: true,
    },

    {
      title: '姓名',
      dataIndex: 'patientName',
      align: 'center',
      width: '8rem',
      ellipsis: true,
    },
    {
      title: '病历号',
      key: 'patientId',
      width: '8rem',
      ellipsis: true,
      align: 'center',
      dataIndex: 'patientId',
    },
    {
      title: '性别',
      key: 'gender',
      width: Dimen.Sex,
      ellipsis: true,
      align: 'center',
      render: (_: string, u: any) => getGenderName(u.patientSex),
    },
    {
      title: '年龄',
      dataIndex: 'patientAge',
      width: Dimen.Age,
      ellipsis: true,
      align: 'center',
      render: (_, r) => getAge(r?.patientAge, r?.patientMonth),
    },
    {
      title: '疾病名称',
      dataIndex: 'disease',
      width:'10rem',
      ellipsis: true,
      align: 'center',
    },
    {
      title: '就诊科室',
      dataIndex: 'treatmentDepartmentName',
      width: '8rem',
      ellipsis: true,
      align: 'center',
    },
    {
      title: '就诊医生',
      dataIndex: 'treatmentDoctorName',
      width: '8rem',
      ellipsis: true,
      align: 'center',
    },
    {
      title: '就诊时间',
      dataIndex: 'registrationTime',
      width: '8rem',
      ellipsis: true,
      align: 'center',
      render: (_, r) => {
        return moment(r.registrationTime).format(DateTimeFormatSimple)
      },
    },

    {
      title: '就诊状态',
      dataIndex: 'registrationState',
      width: Dimen.Status,
      ellipsis: true,
      align: 'center',
      render: (_, r) => getRegistrationStateName(r.registrationState),
    },
    {
      title: '药品用法',
      dataIndex: 'normalUsemethod',
      width: Dimen.Usemethod,
      ellipsis: true,
      key: 'normalUsemethod',
      align: 'center',
    },
    {
      title: '操作',
      align: 'center',
      width: '10rem',
      ellipsis: true,
      render: function element(_, t) {
        return (
          <>
            <Button
              type='primary'
              size='small'
              onClick={(e: any) => {
                onclick('执行', t )
              }}
            >
              执行
            </Button>
            <Button
              style={{marginLeft:'10px'}}
              type='primary'
              ghost
              size='small'
              onClick={(e: any) => {
                onclick('打印', t)
              }}
            >
              打印
            </Button>
          </>
        )
      },
    },
  ]
}
